import * as React from 'react';

const Special = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={14} height={14} fill="currentColor" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M-1063-563H937V637h-2000z" />
            <rect width={56} height={56} x={256} y={129} rx={4} transform="translate(-291 -150)" />
            <path d="M-25-21h48v56h-48c-6.627 0-12-5.373-12-12V-9c0-6.627 5.373-12 12-12" />
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="m.806 6.64 6.87 6.75.01.009a1.167 1.167 0 0 0 1.639-.013l4.12-4.12a1.167 1.167 0 0 0-.006-1.657L6.592.875Q6.578.858 6.56.843A2.2 2.2 0 0 0 5.165.271H1.378C.734.271.212.794.212 1.438l.004 3.789a2.2 2.2 0 0 0 .59 1.414m2.03-2.869a.875.875 0 1 1 1.75 0 .875.875 0 0 1-1.75 0"
            />
        </g>
    </svg>
);
export default Special;
